import React from "react";
import ReactMarkdown from "react-markdown";
import { Button } from "@zapier/design-system";
import styles from "./Composer.module.css";

interface ReasoningPartProps {
  reasoning: string;
  isCollapsed: boolean;
  onToggleCollapse: () => void;
  isCompleted: boolean;
}

export const ReasoningPart: React.FC<ReasoningPartProps> = ({
  reasoning,
  isCollapsed,
  onToggleCollapse,
  isCompleted,
}) => {
  return (
    <div className={styles.reasoningContainer}>
      <Button
        onClick={onToggleCollapse}
        aria-expanded={!isCollapsed}
        color="ghost"
      >
        <div className={styles.reasoningToggleButton}>
          <span>{isCollapsed ? "Show reasoning" : "Hide reasoning"}</span>
          <span
            className={isCollapsed ? styles.triangleRight : styles.triangleDown}
          ></span>
          {!isCompleted && (
            <span className={styles.reasoningStreamIndicator}>
              <span className={styles.reasoningPulsingDot}></span>
            </span>
          )}
        </div>
      </Button>
      <div
        className={`${styles.reasoningContent} ${isCollapsed ? styles.reasoningCollapsed : ""}`}
      >
        {!isCollapsed && <ReactMarkdown>{reasoning}</ReactMarkdown>}
      </div>
    </div>
  );
};
